import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CatalogSnippetComponent } from './catalog-snippet.component';
import { NgAisModule } from 'angular-instantsearch';

import { LikeModule } from '@app/shared/components/like/like.module';
import { SvgModule } from '@app/shared/components/svg/svg.module';

import { ImagesModule } from '@app/shared/components/images/images.module';
import { RefModule } from '@app/shared/components/ref/ref.module';

@NgModule({
  imports: [CommonModule, RouterModule, NgAisModule, CommonModule, SvgModule, LikeModule, ImagesModule, RefModule],
  exports: [CatalogSnippetComponent, RouterModule],
  declarations: [CatalogSnippetComponent]
})
export class CatalogSnippetModule {}
